/**
 * MoodStir network traffic can contain guest PII, uploaded media, Firebase
 * credentials, or event capabilities. Replay tooling receives no network
 * request/response metadata or bodies; application diagnostics use the
 * separately redacted first-party logger instead.
 */
export function dropReplayNetworkCapture(_payload?: unknown): null {
  return null;
}
